import styled from "styled-components";

export const SocialIconsContainer = styled.div` 
    display: flex;
    flex-wrap: wrap;
`;

export const IconContainer = styled.div`
    margin: 0 8px;

    :hover {
        .instagram {
            path {
                fill: #dc297b;
            }
        }
    }

    :hover {
        .twitter {
            path {
                fill: #00acee;
            }
        }
    }

    :hover {
        .github {
            path {
                fill: black;
            }
        }
    }

    :hover {
        .linked-in {
            path {
                fill: navy;
            }
        }
    }

    :hover {
        .mail {
            path {
                fill: darkred;
            }
        }
    }
`;